import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CREHANA_PLAYER_TRANSLATION_KEY } from "./constants";
export default /*#__PURE__*/_defineProperty({}, CREHANA_PLAYER_TRANSLATION_KEY, {
  ERROR_VIDEO: 'There was an error with the video. Try to refresh your browser.',
  BACK_LABEL: 'Back',
  SEE_MORE: 'See more',
  CLOSE: 'Close',
  // LANGUAGE LABELS
  SPANISH: 'Spanish',
  PORTUGUESE: 'Portuguese',
  ENGLISH: 'English',
  // Controlbar
  ADD_NOTE_LABEL: 'Add note',
  SETTINGS_LABEL: 'Settings',
  FULLSCREEN_LABEL: 'Fullscreen',
  FULLSCREEN_DISABLE_LABEL: 'Leave fullscreen',
  FULLSCREEN_NOT_AVAILABLE: 'Fullscreen not available',
  PIP_LABEL: 'Picture in picture',
  DISABLE_PIP_LABEL: 'Disable picture in picture',
  MUTE_LABEL: 'Mute',
  UNMUTE_LABEL: 'Unmute',
  FORWARD_LABEL: '10 seconds forward',
  BACKWARD_LABEL: '10 seconds backward',
  PLAY_LABEL: 'Play',
  PAUSE_LABEL: 'Pause',
  REPLAY_LABEL: 'Replay',
  CC_LABEL: 'Audio and subtitles',
  // Settings
  SPEED: 'Speed',
  QUALITY: 'Video quality',
  AUTO_QUALITY: 'Auto',
  AUDIO: 'Audio',
  SUBTITLES: 'Subtitles',
  DISABLED_SUBTITLES: 'Disabled',
  BACK_TO_VIDEO: 'Back to video',
  AUTOPLAY: 'Autoplay',
  SHOW_NOTES: 'Show notes',
  // Endscreen
  ENDSCREEN_START_IN: 'will start in {{count}} second',
  ENDSCREEN_START_IN_plural: 'will start in {{count}} seconds',
  ENDSCREEN_WATCH_NOW: 'Start',
  CANCEL: 'Cancel',
  NEXT_LECTURE: 'Next lesson',
  SKIP_VIDEO: 'Watch next lesson',
  // Idle screen
  IDLESCREEN_TITLE: 'Are you still there?',
  IDLESCREEN_CONTINUE: 'Watch next lesson',
  IDLESCREEN_GO_BACK: 'Restart the module',
  IDLESCREEN_IGNORE: 'Do not show again',
  // Confirmation overlay
  CONFIRMATION_TITLE_W_NAME: '{{name}}, the video is almost completed',
  CONFIRMATION_TITLE: 'The video is almost completed',
  CONFIRMATION_DETAIL: 'There are only {{minutes}} remaining',
  CONFIRMATION_LEAVE: 'Leave the lesson',
  CONFIRMATION_CONTINUE: 'Keep watching',
  // Quality warnings
  HD: 'HD',
  RECOMMENDED: 'recommended',
  LOW_QUALITY_WARNING_TITLE: 'Your video quality is low',
  LOW_QUALITY_WARNING_DESCRIPTION: 'We reduce the quality because the connection is slow, the images may not be clear.',
  LOW_QUALITY_WARNING_CTA: 'Adjust the quality on this icon',
  MANUAL_HIGH_QUALITY_WARNING_TITLE: 'You improved your video quality!',
  MANUAL_HIGH_QUALITY_WARNING_DESCRIPTION: 'Remember that if your **connection speed is slow**, your classes may take **time to load**.',
  MANUAL_HIGH_QUALITY_WARNING_CTA: 'You can adjust the quality as many times as you want on this icon',
  // Error overlay
  ERROR_TITLE: "We're experiencing a problem playing this video",
  ERROR_DESC: 'We recommend that you update your browser or try again later.',
  AI_LABEL: 'Notes with AI',
  AI_LABEL_TITLE: 'Class notes',
  AI_LABEL_TITLE_LONG: 'Class notes with AI',
  AI_SKIP_BUTTON_LABEL: 'Generate notes',
  AI_TAG: 'Beta',
  AI_ERROR_TITLE: 'An error occurred while generating the notes',
  AI_ERROR_SUBTITLE: 'Please try again',
  AI_SUCCESS_TOAST_TITLE: 'Your notes were saved successfully',
  AI_SUCCESS_TOAST_SUBTITLE: 'You will find them in the notes section inside the classroom',
  AI_SUCCES_LABEL: 'Understood',
  AI_CTA_BUTTON_SAVE: 'Save',
  AI_LABEL_SUGGESTED: 'Suggested notes',
  AI_SUGGESTIONS_DESCRIPTION: 'Select an idea and with the save button, add it to your notes section, where you can edit it from there',
  AI_DESCRIPTION_SHORT: 'Generate summary after each class with AI to reinforce your knowledge',
  AI_DESCRIPTION: 'At the end of each class you will be able to generate a summary with our artificial intelligence to reinforce your knowledge',
  AI_CTA_BUTTON: 'Generate notes',
  AI_CTA_NEW_BUTTON: 'Generate new notes',
  AI_SUCCESS_LABEL: 'Start next class',
  AI_SUCCESS_TITLE: 'You have saved all the generated notes',
  AI_LOADING: 'We are generating your class summary with artificial intelligence',
  AI_SUCCESS_SUBTITLE: 'You can generate notes again if you wish',
  CUSTOM_GENERATE_AI: 'They are generated by an artificial intelligence to help you better understand your video lectures. [Learn more](https://ayuda.crehana.com/)',
  CUSTOM_GENERATE_AI1: 'Use the notes as a study tool, but not as a substitute, review the lectures first.',
  CUSTOM_GENERATE_AI2: 'The "beta" version, is offered to a limited group of users for feedback and improvement before official release.',
  // Key names
  SPACE: 'space',
  ARROW_UP: 'arrow up',
  ARROW_DOWN: 'arrow down',
  M: 'm',
  ARROW_LEFT: 'arrow left',
  ARROW_RIGHT: 'arrow right',
  F: 'f',
  A: 'a',
  BLOCKED_TITLE: 'Advance blocked',
  BLOCKED_BUTTON_LABEL: 'Continue',
  BLOCKED_TIMESTAMP_LABEL: 'You must finish watching the entire class to advance in the course. It is not possible to skip ahead.'
});